// messageEpic.ts
import { ofType } from 'redux-observable'
import type { Epic } from 'Flux/index.js'
import { filter, timer } from 'rxjs'
import { mergeMap, map } from 'rxjs/operators'
import type { IMessage } from '../../../Model/Message/IMessage.js'
import { addMessage, removeMessage } from '../../Slice/Application/ApplicationSlice.js'
import { SNACKBAR_TIMEOUT } from '../../../Model/Message/IMessage.js'

export const messageEpic: Epic = (action$) =>
  action$.pipe(
    ofType(addMessage.type),
    filter((action: { payload: IMessage }) => !action.payload.duration || Number.isFinite(action.payload.duration)),
    mergeMap((action: { payload: IMessage }) => {
      const { id, duration = SNACKBAR_TIMEOUT } = action.payload
      return timer(duration).pipe(map(() => removeMessage(id)))
    })
  )
